import { render } from "./InsurerManagerList.vue?vue&type=template&id=3b2ff1b7"
import script from "./InsurerManagerList.vue?vue&type=script&lang=js"
export * from "./InsurerManagerList.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./InsurerManagerList.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_f20077cc%2Fpackages%2Finsurer%2Fsrc%2Fviews%2Finternal%2FInsurerManagerList.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__